import styled from 'styled-components';

const Titulo = styled.h1`
    font: normal 22.976px 'Lexend Deca';
    line-height: 29px;

    color: #126BA5;

    padding-top: 98px;
`;

const Subtitulo = styled.h2`
    font: normal 17.796px 'Lexend Deca';
    line-height: 22px;

    color: ${props => props.porcentagem === 0 ? '#BABABA' : '#8FC549'}
`

export {
    Titulo,
    Subtitulo
}